<div class="fixed inset-0 z-50 flex items-center justify-center bg-black/40 p-4" [dir]="isArabic() ? 'rtl' : 'ltr'">
  <div class="max-h-[80vh] max-w-4xl w-full overflow-y-auto rounded-xl bg-white p-4 shadow-xl">
    <div class="mb-1 flex items-start justify-between">
      <div>
        <h3 class="text-[17px] font-bold text-gray-900">
          {{ isArabic() ? "تأكيد كمية المنتج المطلوبة" : "Confirm Product Ordered Quantity" }}
        </h3>
        <p class="mt-0.5 text-[13px] text-gray-400">
          {{
            isArabic()
              ? "أنت على وشك تأكيد المتابعة بالكمية المتبقية من هذا المنتج."
              : "You are about to confirm continue with remaining quantity from this product."
          }}
        </p>
      </div>
      <button
        (click)="onCancelClick()"
        class="rounded-lg p-1 text-gray-400 transition-colors hover:bg-gray-100 hover:text-gray-600">
        <app-cancel-icon />
      </button>
    </div>

    <!--
      PREVIOUS BUNDLE POPUP LAYOUT (vertical, stacked Before/After) - kept for reference:
      <div class="mt-3 flex flex-col gap-1.5">
        <span ...>الكمية المطلوبة الفعلية</span>
        <app-order-bundle-item [showOnlyPackaged]="false" [isReadOnly]="true" />
      </div>
      <div class="my-1.5 flex justify-center">vertical arrow</div>
      <div class="flex flex-col gap-1.5">
        <span ...>الكمية المتبقية (بعد التأكيد)</span>
        <app-order-bundle-item [showOnlyPackaged]="true" [isReadOnly]="true" />
      </div>
    -->
    @if (itemType() === "bundle" && data().bundle) {
      <div class="mt-3 flex flex-col gap-1.5 md:flex-row md:items-stretch md:gap-2">
        <div class="flex min-w-0 flex-1 flex-col gap-1.5">
          <span class="text-[13px] font-bold text-gray-700">
            {{ isArabic() ? "الكمية المطلوبة الفعلية" : "Actual ordered quantity" }}
          </span>
          <app-order-bundle-item
            [productTitle]="isArabic() ? data().bundle!.titleAr! : data().bundle!.titleEn!"
            [products]="data().bundle!.products"
            [totalBusinessPrice]="+(data().totalPharmacyPrice || 0)"
            [quantity]="data().orderedQuantity"
            [profileImageFid]="data().bundle!.profileImageFid"
            [totalBusinessPriceBeforeDiscount]="data().bundle!.totalBusinessPriceBeforeDiscount"
            [bundleDiscountType]="data().bundle!.discountType"
            [bundleDiscountValue]="data().bundle!.discountValue"
            [packageQuantity]="data().packageQuantity ?? null"
            [notPackageRows]="data().notPackageRows ?? null"
            [businessPrice]="data().product.businessPrice ?? data().product.storePrice"
            [showOnlyPackaged]="false"
            [isReadOnly]="true" />
        </div>

        <div class="flex items-center justify-center py-1">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            class="text-gray-400"
            [class.rotate-180]="isArabic()">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </div>

        <div class="flex min-w-0 flex-1 flex-col gap-1.5">
          <span class="text-[13px] font-bold text-gray-700">
            {{ isArabic() ? "الكمية المتبقية (بعد التأكيد)" : "Remaining quantity" }}
          </span>
          <app-order-bundle-item
            [productTitle]="isArabic() ? data().bundle!.titleAr! : data().bundle!.titleEn!"
            [products]="data().bundle!.products"
            [totalBusinessPrice]="+(data().totalPharmacyPrice || 0)"
            [quantity]="data().remainingQuantity ?? data().availableQuantity"
            [profileImageFid]="data().bundle!.profileImageFid"
            [totalBusinessPriceBeforeDiscount]="data().bundle!.totalBusinessPriceBeforeDiscount"
            [bundleDiscountType]="data().bundle!.discountType"
            [bundleDiscountValue]="data().bundle!.discountValue"
            [packageQuantity]="data().packageQuantity ?? null"
            [notPackageRows]="data().notPackageRows ?? null"
            [businessPrice]="data().product.businessPrice ?? data().product.storePrice"
            [showOnlyPackaged]="true"
            [isReadOnly]="true" />
        </div>
      </div>
    } @else {
      <!--
        PREVIOUS PRODUCT POPUP LAYOUT (vertical, stacked Before/After) - kept for reference:
        <div class="mt-3 flex flex-col gap-1.5">
          <span>الكمية المطلوبة الفعلية</span>
          <app-order-product-item [showOnlyPackaged]="false" [isReadOnly]="true" />
        </div>
        <div class="my-1.5 flex justify-center">vertical down arrow</div>
        <div class="flex flex-col gap-1.5">
          <span>الكمية المتبقية (بعد التأكيد)</span>
          <app-order-product-item [showOnlyPackaged]="true" [isReadOnly]="true" />
        </div>
      -->
      <div class="mt-3 flex flex-col gap-1.5 md:flex-row md:items-stretch md:gap-2">
        <div class="flex min-w-0 flex-1 flex-col gap-1.5">
          <span class="text-[13px] font-bold text-gray-700">
            {{ isArabic() ? "الكمية المطلوبة الفعلية" : "Actual ordered quantity" }}
          </span>

          @if (data().product) {
            <app-order-product-item
              [productTitle]="isArabic() ? data().product.titleAr : data().product.titleEn"
              [mfgDate]="data().product.mfgDate"
              [expDate]="data().product.expDate"
              [businessPrice]="data().product.businessPrice ?? data().product.storePrice"
              [peoplePrice]="data().product.customerPrice ?? data().product.peoplePrice"
              [totalBusinessPrice]="+(data().totalPharmacyPrice || 0)"
              [quantity]="data().orderedQuantity"
              [batchNumber]="data().product.batchNumber"
              [profileImageFid]="data().product.profileImageFid"
              [packageQuantity]="data().packageQuantity ?? null"
              [notPackageRows]="data().notPackageRows ?? null"
              [showOnlyPackaged]="false"
              [isReadOnly]="true" />
          }
        </div>

        <div class="flex items-center justify-center py-1">
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            stroke-width="2"
            class="text-gray-400"
            [class.rotate-180]="isArabic()">
            <line x1="5" y1="12" x2="19" y2="12"></line>
            <polyline points="12 5 19 12 12 19"></polyline>
          </svg>
        </div>

        <div class="flex min-w-0 flex-1 flex-col gap-1.5">
          <span class="text-[13px] font-bold text-gray-700">
            {{ isArabic() ? "الكمية المتبقية (بعد التأكيد)" : "Remaining quantity" }}
          </span>

          @if (data().product) {
            <app-order-product-item
              [productTitle]="isArabic() ? data().product.titleAr : data().product.titleEn"
              [mfgDate]="data().product.mfgDate"
              [expDate]="data().product.expDate"
              [businessPrice]="data().product.businessPrice ?? data().product.storePrice"
              [peoplePrice]="data().product.customerPrice ?? data().product.peoplePrice"
              [totalBusinessPrice]="+(data().totalPharmacyPrice || 0)"
              [quantity]="data().remainingQuantity ?? data().availableQuantity"
              [batchNumber]="data().product.batchNumber"
              [profileImageFid]="data().product.profileImageFid"
              [packageQuantity]="data().packageQuantity ?? null"
              [notPackageRows]="data().notPackageRows ?? null"
              [showOnlyPackaged]="true"
              [isReadOnly]="true" />
          }
        </div>
      </div>
    }

    <div
      class="mt-3 flex items-center gap-2.5 rounded-lg border border-amber-300 bg-amber-50 px-4 py-2 text-[12px] font-medium text-amber-800">
      <span>
        {{
          isArabic()
            ? "سيتم تحديث ملخص الطلب بعد هذا التغيير، هل تريد المتابعة؟"
            : "The order summary will be updated after this change. Do you want to proceed?"
        }}
      </span>
    </div>

    <div class="mt-4 flex justify-end gap-3">
      <button
        (click)="onCancelClick()"
        class="h-10 w-28 cursor-pointer rounded-lg border border-gray-300 text-[13px] font-bold text-gray-600 transition-colors hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-70">
        {{ isArabic() ? "إلغاء" : "Cancel" }}
      </button>

      <app-submit-button
        type="primary"
        class="[&>button]:h-10 [&>button]:w-28 [&>button]:!w-28 [&>button]:!py-0 flex items-center justify-center"
        (click)="onConfirmClick()">
        {{ isArabic() ? "تأكيد" : "Confirm" }}
      </app-submit-button>
    </div>
  </div>
</div>
